module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 12 12",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_6985_159361)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.5714 1.2832H0.428571C0.191518 1.2832 0 1.47472 0 1.71177V10.2832C0 10.5203 0.191518 10.7118 0.428571 10.7118H11.5714C11.8085 10.7118 12 10.5203 12 10.2832V1.71177C12 1.47472 11.8085 1.2832 11.5714 1.2832ZM11.0357 9.74749H0.964286V9.21311L2.8192 7.01267L4.82946 9.3966L7.9567 5.68945L11.0357 9.34035V9.74749ZM11.0357 8.0091L8.03839 4.45463C7.99554 4.40374 7.91786 4.40374 7.875 4.45463L4.82946 8.06535L2.90089 5.77919C2.85804 5.72829 2.78036 5.72829 2.7375 5.77919L0.964286 7.88186V2.24749H11.0357V8.0091ZM3.21429 5.24749C3.36906 5.24749 3.52231 5.217 3.66531 5.15778C3.8083 5.09855 3.93822 5.01173 4.04766 4.90229C4.1571 4.79285 4.24391 4.66293 4.30314 4.51994C4.36237 4.37695 4.39286 4.22369 4.39286 4.06892C4.39286 3.91415 4.36237 3.76089 4.30314 3.6179C4.24391 3.47491 4.1571 3.34498 4.04766 3.23554C3.93822 3.1261 3.8083 3.03929 3.66531 2.98006C3.52231 2.92083 3.36906 2.89035 3.21429 2.89035C2.90171 2.89035 2.60193 3.01452 2.38091 3.23554C2.15988 3.45657 2.03571 3.75634 2.03571 4.06892C2.03571 4.38149 2.15988 4.68127 2.38091 4.90229C2.60193 5.12332 2.90171 5.24749 3.21429 5.24749V5.24749ZM3.21429 3.69392C3.42188 3.69392 3.58929 3.86133 3.58929 4.06892C3.58929 4.27651 3.42188 4.44392 3.21429 4.44392C3.0067 4.44392 2.83929 4.27651 2.83929 4.06892C2.83929 3.86133 3.0067 3.69392 3.21429 3.69392Z",
      "fill": "black",
      "fill-opacity": "0.85"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_6985_159361"
    }
  }, [_c('rect', {
    attrs: {
      "width": "12",
      "height": "12",
      "fill": "white"
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-565a92ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-565a92ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/Picture.vue
// module id = 1501
// module chunks = 159